define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare, _, PathMatrix, xml) {

	return declare(PathMatrix, {

		/**
		 * @override
		 */
		addDependencyPaths: function(h, paths) {
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec/Child:SellingCountries/Child:Languages");
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Get the Language under the ProductSalesRegion and display them as the row on the table second column
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			const salesRegionSpecNode = node ? ctx.cache.getNode(node.ProductSalesRegionSpec) : null;
			let languages = [];

			if (salesRegionSpecNode) {
				_.each(salesRegionSpecNode.SellingCountries, function(countryURL) {
					const country = ctx.cache.getNode(countryURL);
					languages = languages.concat(ctx.cache.getNodes(country.Languages));
				});
			}

			return _.uniq(languages);
		}

	});
});